import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  showMoreClicked: false,
};

const showMoreSlice = createSlice({
  name: 'showMore',
  initialState,
  reducers: {
    setShowMoreClicked: (state, action) => {
      state.showMoreClicked = action.payload;
    },
  },
});

export const { setShowMoreClicked } = showMoreSlice.actions;
export default showMoreSlice.reducer;
